import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="post";
export function selectAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectOne(parameter){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/${parameter}`,
    method: 'get',
  })
}

export function listAllPost(parameter){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/listAllPost`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectPostTree(parameter){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectPostTree/${parameter}`,
    method: 'get'
  })
}

export function selectPostBydepId(parameter){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectPostBydepId/${parameter}`,
    method: 'get'
  })
}

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}


export function deleteObj(ids){
  console.log("ids",ids)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params:ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export default {
  selectAll,
  selectOne,
  selectPostBydepId,
  listAllPost,
  update,
  save:insert,
  delete:deleteObj,
  selectPostTree
}